// extracted by mini-css-extract-plugin
module.exports = {"PageTransition":"styles_PageTransition__319ND"};